var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9752 3.71715C12.517 3.21731 11.6896 3.18651 11.138 3.73808L5.738 9.13808C5.59835 9.27773 5.59835 9.45562 5.738 9.59527C5.87765 9.73492 6.05554 9.73492 6.19519 9.59527L10.6619 5.1286C10.9222 4.86825 11.3443 4.86825 11.6047 5.1286C11.865 5.38895 11.865 5.81106 11.6047 6.07141L7.138 10.5381C6.47765 11.1984 5.45554 11.1984 4.79519 10.5381C4.13484 9.87773 4.13484 8.85562 4.79519 8.19527L10.1952 2.79527C11.2402 1.75025 12.9384 1.71624 13.9482 2.80547C14.983 3.85108 15.0135 5.54105 13.9285 6.54755L7.60466 12.8714C6.14432 14.3318 3.85554 14.3318 2.39519 12.8714C0.934839 11.4111 0.934839 9.12228 2.39519 7.66193L7.79519 2.26193C8.05554 2.00158 8.47765 2.00158 8.738 2.26193C8.99835 2.52228 8.99835 2.94439 8.738 3.20474L3.338 8.60474C2.39835 9.54439 2.39835 10.9889 3.338 11.9286C4.27765 12.8683 5.72221 12.8683 6.66186 11.9286L12.9952 5.59527C13.002 5.58844 13.009 5.58176 13.0161 5.57523C13.516 5.11705 13.5468 4.28964 12.9952 3.73808C12.9884 3.73125 12.9817 3.72427 12.9752 3.71715Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.60ae7db3e1b67e2af5236250f6fcb7a8.svg";
export { ForwardRef as ReactComponent };